document.addEventListener("DOMContentLoaded", function() {
    var form = document.querySelector(".form-contact");
    var alertField = form.querySelector("#alert");
    form.addEventListener("submit", function(event) {
        console.log("form submit");
        event.preventDefault();
        if (!form.checkValidity()) {
            alertField.innerHTML = "Vypl\u0148te pros\xedm v\u0161echna pole formul\xe1\u0159e.";
            alertField.classList.add("opacity-100");
            alertField.classList.remove("hidden");
            return;
        }
        if (!form.querySelector('input[type="checkbox"]').checked) {
            alertField.innerHTML = "Pro odesl\xe1n\xed formul\xe1\u0159e je nutn\xe9 souhlasit se zpracov\xe1n\xedm osobn\xedch \xfadaj\u016F.";
            alertField.classList.add("opacity-100");
            alertField.classList.remove("hidden");
            return;
        }
        if (form.querySelector("input#captcha").value !== "netion") {
            console.log(form.querySelector("input#captcha").value);
            alertField.innerHTML = "Opi\u0161te pros\xedm slovo netion do pole pro ov\u011B\u0159en\xed.";
            alertField.classList.add("opacity-100");
            alertField.classList.remove("hidden");
            return;
        }
        if (form.querySelector("input#phone").value.length > 1 && form.querySelector("input#phone").value.length < 9) {
            alertField.innerHTML = "Zadejte pros\xedm platn\xe9 telefonn\xed \u010D\xedslo.";
            alertField.classList.add("opacity-100");
            alertField.classList.remove("hidden");
            return;
        }
        var formData = new FormData(form);
        fetch("send_email.php", {
            method: "POST",
            body: formData
        }).then(function(response) {
            return response.json();
        }).then(function(data) {
            if (data.success) {
                console.log(data);
                alertField.classList.add("opacity-100");
                alertField.classList.remove("hidden");
                alertField.innerHTML = "D\u011Bkujeme za odesl\xe1n\xed formul\xe1\u0159e. Brzy se v\xe1m ozveme.";
                form.reset();
            } else {
                console.log(data);
                alert("Odesl\xe1n\xed emailu selhalo. Zkuste to pros\xedm znovu.");
            }
        })["catch"](function(error) {
            console.error("Error:", error);
            alert("Chyba p\u0159i odesl\xe1n\xed. Zkuste to pros\xedm znovu.");
        });
    });
});

//# sourceMappingURL=index.dd2198bd.js.map
